export const LOGIN_TRACK_EVENT = {
  CATEGORY: 'Login',
  ACTION: {
    NAME: 'Se connecter',
    SUCCESS: 'Connexion réussie',
    UNAUTHORIZED: 'Compte non autorisé',
    ERROR: "Erreur d'authentification",
  },
};
